import React, { useState, useRef, useEffect } from 'react';
import styles from './css/ThreeDotMenu.module.css'; // Import the CSS module
import 'material-icons/iconfont/material-icons.css';


const ThreeDotMenu = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };
  

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <ul className={styles.headerDropdown} ref={ref}>
      <li className={styles.dropdown}>
        <button className={styles.dropdownToggle} onClick={() => setOpen(!open)}>
          <i className="material-icons">more_vert</i>
        </button>
        <ul className={`${styles.dropdownMenu} ${open ? styles.show : ''}`}>
          <li className={styles.dropdownMenuItem}>
            <a href="#" onClick={() => window.history.back()}>Back</a>
          </li>
          <li className={styles.dropdownMenuItem}>
            <a href="#" onClick={() => window.close('', '_parent', '')}>Close</a>
          </li>
          <li className={styles.dropdownMenuItem}>
            <a href="#" onClick={() => window.location.reload()}>Refresh</a>
          </li>
        </ul>
      </li>
    </ul>
  );
};

export default ThreeDotMenu;
  
